import { RefObject, useCallback, useEffect, useState } from 'react';

export const useFade = (ref: RefObject<HTMLElement | null>) => {
  const [fadeLeft, setFadeLeft] = useState(false);
  const [fadeRight, setFadeRight] = useState(false);

  const update = useCallback(() => {
    const el = ref.current;

    if (!el) {
      return;
    }

    setFadeLeft(el.scrollLeft > 0);
    setFadeRight(Math.ceil(el.scrollLeft) + el.clientWidth < el.scrollWidth);
  }, [ref]);

  useEffect(() => {
    const el = ref.current;

    if (!el) {
      return;
    }

    update();
    el.addEventListener('scroll', update, { passive: true });

    const observer = new ResizeObserver(update);
    observer.observe(el);

    return () => {
      el.removeEventListener('scroll', update);
      observer.disconnect();
    };
  }, [ref, update]);

  return { fadeLeft, fadeRight };
};
